import { getRouteTitle } from './utils';


const sendEvents = async (eventName, eventProperties) => {
    const webhookUrl = 'https://in-webhook.hevodata.com/t/1csm26a3ux';
    let userData = await localStorage.getItem('user');
    if (userData) {
        userData = JSON.parse(userData);
    }
    const DEV = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
    const properties = {
        eventName: eventName,
        sessionId: global.sessionId,
        timeStamp: Date.now(),
        userId: userData.email,
        // platform: getPlatformType(),
        screen: getRouteTitle(window.location.pathname),
        host: window.location.hostname,
        ...eventProperties
    };
    const requestData = { event: 'hevo_events', properties };
    !DEV && fetch(webhookUrl, {
        method: 'POST',
        body: JSON.stringify(requestData)
    })
        .then((response) => {
            if (response.status === 200) {
                console.log('Data sent successfully');
            }
        })
        .catch(function (e) {
            // send logger
        });
};

export { sendEvents };